/**
 * Alarms Module - Mutations
 *
 * State mutations for managing alarm history data
 */

import type { IAlarmData } from '@/models/dtos/AlarmDTO';

/**
 * State interface for the alarms module
 */
export interface AlarmsState {
  /** Array of historical alarm records */
  alarmsHistory: IAlarmData[];
}

/**
 * Factory function to create initial state
 * @returns Fresh alarms state object
 */
export const initialAlarmsState = (): AlarmsState => ({
  alarmsHistory: [],
});

export default {
  /**
   * Set the complete alarm history
   * @param state - Current alarms state
   * @param payload - Array of alarm data records
   */
  setAlarmHistory(state: AlarmsState, payload: IAlarmData[]): void {
    state.alarmsHistory = payload;
  },

  /**
   * Reset alarms state to initial values
   * @param state - Current alarms state
   */
  resetData(state: AlarmsState): void {
    Object.assign(state, initialAlarmsState());
  },
};


